import { all, takeEvery, takeLatest } from 'redux-saga/effects';

/**
 * Auth
 */
import { Types as AuthTypes } from '../ducks/auth';
import { getUser, updateTriiderUser, updateUserLogin } from './auth';

/**
 * Ui
 */
import { Types as UiTypes } from '../ducks/ui';
import { growl } from './ui';

/**
 * Service Form
 */
import { Types as FormTypes } from '../ducks/serviceForm';
import { finishForm } from './serviceForm';

/**
 * SERVICES
 */
import { Types as ServiceTypes } from '../ducks/services';
import { getServicesByCity, getServicesByCategory } from './services';

/**
 * TASKS
 */
import { Types as TaskTypes } from '../ducks/task';
import { getTaskByUser, getTaskDetails } from './task';

export default function* rootSaga() {
  yield all([
    /**
     * Auth
     */
    takeLatest(AuthTypes.GET_USER_BY_HASH_REQUEST, getUser),
    takeLatest(AuthTypes.UPDATE_TRIIDER_USER, updateTriiderUser),
    takeLatest(AuthTypes.UPDATE_USER_LOGIN, updateUserLogin),

    /**
     * Ui
     */
    takeEvery(UiTypes.GROWL_ADDED, growl),

    /**
     * SERVICES FORM
     */
    takeLatest(FormTypes.FINISH_FORM_REQUEST, finishForm),

    /**
     * Service
     */
    takeLatest(ServiceTypes.GET_SERVICES_BY_CITY_REQUEST, getServicesByCity),
    takeLatest(ServiceTypes.GET_SERVICES_BY_CATEGORY_REQUEST, getServicesByCategory),

    /**
     * Tasks
     */

    takeLatest(TaskTypes.GET_TASK_REQUEST, getTaskByUser),
    takeEvery(TaskTypes.GET_TASK_DETAILS_REQUEST, getTaskDetails),
  ]);
}
